import { DateConst } from 'app/shared/date.const';

export class FacetUtils {
  static hronologicalSort<T extends { start: string }>(facets: T[]): T[] {
    return facets.sort((a, b) => {
      if (a.start === null) {
        return 1;
      }
      if (b.start === null) {
        return -1;
      }
      return +DateConst.getYear(a.start) - +DateConst.getYear(b.start);
    });
  }
}
